import {useMemo, useState} from "react";
import Picker from "react-mobile-picker";
import styles from "../styles/login.module.scss";
import {shareState} from "../../../app/share-state";
import {LOGIN} from "../login.widget.consts";

const getMonthLabels = () => {
  const langId = shareState.language?.id;
  return LOGIN.DATE_OF_BIRTH_MONTH_LABELS[langId] || LOGIN.DATE_OF_BIRTH_MONTH_LABELS.default;
};

const pad2 = (n) => String(n).padStart(2, "0");
const getDaysInMonth = (year, month) => new Date(Number(year), Number(month), 0).getDate();

const buildInitialValue = (dateOfBirth) => {
  if (dateOfBirth) {
    const [y, m, d] = dateOfBirth.split("-");
    return {day: d, month: m, year: y};
  }
  const now = new Date();
  return {day: pad2(now.getDate()), month: pad2(now.getMonth() + 1), year: String(now.getFullYear())};
};

export const LoginWidgetDateOfBirthMobileDatePicker = ({dateOfBirth, onConfirm, onCancel}) => {
  const [pickerValue, setPickerValue] = useState(() => buildInitialValue(dateOfBirth));

  const currentYear = new Date().getFullYear();
  const years = useMemo(() => {
    const arr = [];
    for (let y = currentYear; y >= LOGIN.MIN_YEAR; y--) arr.push(String(y));
    return arr;
  }, [currentYear]);
  const months = useMemo(() => Array.from({length: 12}, (_, i) => pad2(i + 1)), []);
  const monthLabels = useMemo(() => getMonthLabels(), []);
  const days = useMemo(() => {
    const max = getDaysInMonth(pickerValue.year, pickerValue.month);
    return Array.from({length: max}, (_, i) => pad2(i + 1));
  }, [pickerValue.year, pickerValue.month]);

  const handleChange = (newValue) => {
    const maxDay = getDaysInMonth(newValue.year, newValue.month);
    const clampedDay = Number(newValue.day) > maxDay ? pad2(maxDay) : newValue.day;
    setPickerValue({...newValue, day: clampedDay});
  };

  const handleConfirm = () => {
    const {year, month, day} = pickerValue;
    onConfirm(`${year}-${month}-${day}`);
  };

  return (
    <div className={styles.date_of_birth_modal_overlay} onClick={onCancel}>
      <div className={styles.date_of_birth_modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.date_of_birth_modal_picker_wrapper}>
          <Picker value={pickerValue} onChange={handleChange} wheelMode="natural">
            <Picker.Column name="day">
              {days.map(d => (
                <Picker.Item key={d} value={d}>{d}</Picker.Item>
              ))}
            </Picker.Column>
            <Picker.Column name="month">
              {months.map(m => (
                <Picker.Item key={m} value={m}>{monthLabels[Number(m) - 1]}</Picker.Item>
              ))}
            </Picker.Column>
            <Picker.Column name="year">
              {years.map(y => (
                <Picker.Item key={y} value={y}>{y}</Picker.Item>
              ))}
            </Picker.Column>
          </Picker>
        </div>
        <div className={styles.date_of_birth_modal_buttons}>
          <button
            type="button"
            className={styles.date_of_birth_modal_button_confirm}
            onClick={handleConfirm}
          >
            {shareState.termsUtils.terms.WC_20222_SELECT}
          </button>
        </div>
      </div>
    </div>
  );
};
